"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCirculatingSupply = getCirculatingSupply;
exports.getStakedSupply = getStakedSupply;
exports.getTreasurySharePerAlpha = getTreasurySharePerAlpha;
exports.getAirdropApr = getAirdropApr;
exports.getAlphaHistoricalMarketCap = getAlphaHistoricalMarketCap;
const decimal_js_1 = require("decimal.js");
const index_js_1 = require("../protocol/index.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const dailyRevenue_js_1 = require("./crons/dailyRevenue.js");
const index_js_2 = require("./index.js");
async function getCirculatingSupply() {
    const circulating_supply_url = "https://api.alphafi.xyz/alpha/circulation";
    const circulatingSupplyResponse = await fetch(circulating_supply_url);
    if (!circulatingSupplyResponse.ok) {
        const errorText = await circulatingSupplyResponse.text();
        throw new Error(`HTTP error! status: ${circulatingSupplyResponse.status}, response: ${errorText}`);
    }
    const circulatingSupply = await circulatingSupplyResponse.json();
    return circulatingSupply.toString();
}
async function getStakedSupply() {
    let response = "";
    const pool = await (0, alphafi_sdk_1.getPool)("ALPHA", false);
    const exchangeRate = await (0, index_js_1.getPoolExchangeRate)("ALPHA", false);
    if (!exchangeRate || !pool)
        throw new Error("ALPHA exchange rate or ALPHA pool not found");
    response = new decimal_js_1.Decimal(pool?.content.fields.xTokenSupply)
        .mul(exchangeRate)
        .div(1e9)
        .toString();
    return response;
}
async function getTreasurySharePerAlpha(params) {
    let response = "";
    const { treasuryTotalHoldingsUsd, circulatingAlphaSupply } = params;
    response = new decimal_js_1.Decimal(treasuryTotalHoldingsUsd)
        .div(new decimal_js_1.Decimal(circulatingAlphaSupply))
        .toString();
    return response;
}
async function getAirdropApr(params) {
    let response = "";
    const { annualisedRevenue, alphaPrice } = params;
    const stakedAlpha = await getStakedSupply();
    response = new decimal_js_1.Decimal(annualisedRevenue)
        .div(new decimal_js_1.Decimal(2))
        .div(new decimal_js_1.Decimal(stakedAlpha))
        .div(new decimal_js_1.Decimal(alphaPrice))
        .mul(new decimal_js_1.Decimal(100))
        .toString();
    return response;
}
// Optimisation: instead of calculating from the start, add instead - need to fetch only one price
async function getAlphaHistoricalMarketCap() {
    const genesis_epoch = 1719519457000; // Genesis epoch in milliseconds
    const genesis_rate = 1250 + 12500 / 24; // Initial rate in tokens per hour (adjusted for team tokens)
    const halving_period_days = 100;
    const endTime = (0, dailyRevenue_js_1.getEndOfDayGMT)(Date.now() - 24 * 60 * 60 * 1000);
    const alphaHistoricalPrices = (await (0, index_js_2.fetchHistoricalPrices)({
        maxTime: endTime,
        minTime: (0, dailyRevenue_js_1.getEndOfDayGMT)(genesis_epoch),
        coinPairs: ["ALPHA/USD"],
    }))["ALPHA/USD"];
    let totalTokens = 1500000; // initial alpha supply
    let currentRate = genesis_rate; // tokens per hour
    let currentTime = genesis_epoch;
    let currentEndOfDay = (0, dailyRevenue_js_1.getEndOfDayGMT)(currentTime);
    const supplyData = [];
    let daysSinceLastHalving = 0;
    while (currentEndOfDay <= endTime) {
        while (currentTime <= currentEndOfDay) {
            if (daysSinceLastHalving >= halving_period_days) {
                currentRate /= 2;
                daysSinceLastHalving = 0;
            }
            totalTokens += currentRate / 60;
            currentTime += 60 * 1000;
        }
        daysSinceLastHalving++;
        let timePricePair;
        if (currentEndOfDay < 1720396799999) {
            // First available historical price
            timePricePair = alphaHistoricalPrices.find((pair) => {
                return pair[0] === 1720396799999;
            });
        }
        else {
            timePricePair = alphaHistoricalPrices.find((pair) => {
                return pair[0] === Number(currentEndOfDay);
            });
        }
        if (!timePricePair) {
            throw new Error(`price not found for ALPHA at ${currentEndOfDay}`);
        }
        const currentPrice = timePricePair[1];
        supplyData.push({
            time: currentEndOfDay,
            marketCap: new decimal_js_1.Decimal(totalTokens).mul(currentPrice).toString(),
        });
        currentEndOfDay += 24 * 60 * 60 * 1000;
    }
    return supplyData
        .map((o) => {
        return { time: o.time.toString(), TVL: o.marketCap };
    })
        .slice(-120); //showing 120 days graph
}
//# sourceMappingURL=alpha.js.map